import { THEMES } from '../../App'
import { ENABLE_MIGRATE_STATS } from '../../constants/settings'
import {
  HARD_MODE_DESCRIPTION,
  HIGH_CONTRAST_MODE_DESCRIPTION,
} from '../../constants/strings'
import Dropdown from '../misc/Dropdown'
import { Feedback } from '../misc/Feedback'
import { MigrationIntro } from '../stats/MigrationIntro'
import { BaseModal } from './BaseModal'
import { SettingsToggle } from './SettingsToggle'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHardMode: boolean
  handleHardMode: Function
  theme: string
  handleThemeChange: (newTheme: string) => void
  isHighContrastMode: boolean
  handleHighContrastMode: Function
  handleMigrateStatsButton: () => void
}

export const SettingsModal = ({
  isOpen,
  handleClose,
  isHardMode,
  handleHardMode,
  theme,
  handleThemeChange,
  isHighContrastMode,
  handleHighContrastMode,
  handleMigrateStatsButton,
}: Props) => {
  return (
    <BaseModal title="Settings" isOpen={isOpen} handleClose={handleClose}>
      <div className="mt-2 flex flex-col divide-y">
        <SettingsToggle
          settingName="Hard Mode"
          flag={isHardMode}
          handleFlag={handleHardMode}
          description={HARD_MODE_DESCRIPTION}
        />
        <div className="mt-2 flex flex-row justify-between gap-4 py-3">
          <div className="mt-2 text-left text-gray-500 dark:text-gray-300">
            Theme
          </div>
          <Dropdown
            selectedItem={theme}
            title={`${theme}`}
            options={Object.values(THEMES)}
            handleSelection={handleThemeChange}
          />
        </div>
        <SettingsToggle
          settingName="High Contrast Mode"
          flag={isHighContrastMode}
          handleFlag={handleHighContrastMode}
          description={HIGH_CONTRAST_MODE_DESCRIPTION}
        />
        <Feedback />
      </div>
      {ENABLE_MIGRATE_STATS && (
        <MigrationIntro handleMigrateStatsButton={handleMigrateStatsButton} />
      )}
    </BaseModal>
  )
}
